import React from "react";
import PropTypes from "prop-types";

const UserFullName = ({ name, firstName, lastName, sharedFirstName,sharedLastName,cssClass }) => {
  // Use 'name' if provided, else build from parts
  const fullName =
    name?.trim() ||
    [sharedFirstName, sharedLastName].filter(Boolean).join(" ") || [firstName, lastName].filter(Boolean).join(" ") ||
    "Guest";
  return <span className={cssClass || "user-name"}>{fullName}</span>;
};

UserFullName.propTypes = {
  name: PropTypes.string,
  firstName: PropTypes.string,   
    lastName: PropTypes.string,
    sharedFirstName: PropTypes.string,
    sharedLastName: PropTypes.string,
  cssClass: PropTypes.string,
};

export default UserFullName;
